import { useState } from "react";
import AddBusinessOwnerAction from "./AddBusinessOwnerAction";
import AddRegisteredTrustee from "./AddRegisteredTrustee";
import { AllNGOBusinessSteps } from "../..";
import styles from "../../NGO.module.scss";
import { ICorporateCustomer } from "../../../../hooks/useCorporateCustomers";

export enum RegisteredTrusteeSteps {
  ADD_TRUSTEE_ACTION = "add_trustee_action",
  ADD_TRUSTEE_STEPS = "add_trustee_steps",
}

interface IRegisteredTrustees {
  handleProceed: (step: number) => void;
  resumeCustomerData: ICorporateCustomer;
  formData: any;
}

const RegisteredTrustees: React.FC<IRegisteredTrustees> = ({
  handleProceed,
  resumeCustomerData,
  formData,
}) => {
  const [currentStep, setCurrentStep] = useState(
    RegisteredTrusteeSteps.ADD_TRUSTEE_ACTION
  );

  const handleNextStep = (_step: RegisteredTrusteeSteps) => {
    setCurrentStep(_step);
  };

  return (
    <div>
      {(() => {
        switch (currentStep) {
          case RegisteredTrusteeSteps.ADD_TRUSTEE_ACTION:
            return <AddBusinessOwnerAction handleNextStep={handleNextStep} />;

          case RegisteredTrusteeSteps.ADD_TRUSTEE_STEPS:
            return (
              <AddRegisteredTrustee
                handleProceed={handleProceed}
                resumeCustomerData={resumeCustomerData}
                formData={formData}
              />
            );

          default:
            return null;
        }
      })()}
    </div>
  );
};

export default RegisteredTrustees;
